import { Info } from "lucide-mui"
import React from "react"

import { type VenuePlanData } from "@/components/plan"
import i18n from "@/i18n"

import { TS_STYLES } from "./styles"

type FloorTabsProps = {
  plans: VenuePlanData[]
  activeIndex: number
  onSelect: (index: number) => void
  onShowHowItWorks?: () => void
}

/**
 * Mobile floor-tabs row (Figma 1283-10). Renders the venue plan sections as tabs plus the `(i)`
 * "How it works?" trigger at the far right. Drives `PlanViewer`'s active section externally so the
 * `(i)` icon can share the tab row without changing PlanViewer's built-in tab layout.
 */
const FloorTabs: React.FC<FloorTabsProps> = ({ plans, activeIndex, onSelect, onShowHowItWorks }) => {
  const plansWithContent = plans.filter((plan) => plan.plan)

  return (
    <div className={TS_STYLES.tabsRow} data-testid="public-reservation-modal-mobile-floor-tabs">
      <div className={TS_STYLES.tabsGroup}>
        {plansWithContent.map((plan, index) => {
          const isActive = index === activeIndex
          return (
            <button
              key={plan.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`${TS_STYLES.tab} ${isActive ? TS_STYLES.tabActive : TS_STYLES.tabInactive}`}
              onClick={() => onSelect(index)}
              data-testid={`public-reservation-modal-mobile-floor-tab-${plan.id}`}
            >
              <span>{plan.sectionName}</span>
              {isActive ? <div className={TS_STYLES.tabUnderline} /> : null}
            </button>
          )
        })}
      </div>

      <button
        type="button"
        className={TS_STYLES.infoBtn}
        aria-label={i18n.t("app.public.venue.table_selection.how_it_works")}
        onClick={() => onShowHowItWorks?.()}
        data-testid="public-reservation-modal-mobile-how-it-works-btn"
      >
        <Info className="h-5 w-5" />
      </button>
    </div>
  )
}

export default FloorTabs
